import baseMoment from 'moment';
import { extendMoment } from 'moment-range';
import createCachedSelector from 're-reselect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TrendTimeline from '../../components/chart/TrendTimeline/TrendTimeline';
import { setExpandTrendTimeline, setQuickRange } from '../../state/actions/chart';
import { changePlaybackTime } from '../../state/actions/playback';
import * as fromState from '../../state/reducers';
import * as chartSelectors from '../../state/selectors/chart';
import { CHART_TYPE, ENTITY_TYPE, CHART_VIEW, DATE_FORMAT } from '../../utils/constants';
const moment = extendMoment(baseMoment);

export const getBrushTimes = (startTimestamp, endTimestamp) => {
  if (!startTimestamp && !endTimestamp) {
    return [null, null];
  };
  return [
    moment.utc(startTimestamp, 'X').toISOString(),
    moment.utc(endTimestamp, 'X').toISOString()
  ];
};

const mapStateToProps = createCachedSelector(
  [
    (state, { chartType }) => fromState.getToDate(state, chartType),
    (state, { chartType }) => chartSelectors.getCompareTrend(state, chartType),
    state => fromState.getQuickRange(state, CHART_TYPE.MAIN),
    (state, { chartType }) => chartSelectors.getTimelineTrends(state, chartType),
    fromState.getUnitPath,
    (state, { chartType }) => fromState.getView(state, chartType),
    (state, { chartType }) => fromState.getBrushStartTimestamp(state, chartType),
    (state, { chartType }) => fromState.getBrushEndTimestamp(state, chartType),
    (state, { chartType }) => chartSelectors.getTrendTimelineHeight(state, chartType),
    (state, { chartType }) => fromState.getExpandTrendTimeline(state, chartType),
    state => fromState.getAll(state, ENTITY_TYPE.TREND_TYPE),
    (state, { chartType }) => chartType
  ],
  (
    toDate,
    compareTrend,
    quickRange,
    trends,
    unitPath,
    view,
    brushStartTimestamp,
    brushEndTimestamp,
    height,
    expand,
    allTrendTypes,
    chartType
  ) => {
    const [brushStartTime, brushEndTime] = view === CHART_VIEW.TIME_SERIES
      ? getBrushTimes(brushStartTimestamp, brushEndTimestamp)
      : [null, null];
    const quickRangeDuration = moment.duration(quickRange);
    if (chartType === CHART_TYPE.COMPARE) {
      return {
        endTime: brushEndTime || compareTrend.to,
        startTime: brushStartTime
          || moment.utc(compareTrend.to).subtract(quickRangeDuration).toISOString(),
        trends,
        unitPath,
        currentTrendId: compareTrend.id,
        allTrendTypes,
        height,
        expand
      };
    };

    return {
      endTime: brushEndTime || moment.utc(toDate, DATE_FORMAT).toISOString(),
      startTime: brushStartTime
        || moment.utc(toDate, DATE_FORMAT).subtract(quickRangeDuration).toISOString(),
      trends,
      unitPath,
      allTrendTypes,
      height,
      expand
    };
  }
)(
  (state, { chartType }) => chartType
);

const mapDispatchToProps = (dispatch, { chartType }) => bindActionCreators({
  onSelectTime: changePlaybackTime,
  onSetQuickRange: quickRange => setQuickRange(CHART_TYPE.MAIN, quickRange),
  onSetExpand: value => setExpandTrendTimeline(chartType, value)
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TrendTimeline);